<template>
  <div class="flex items-center">
    <span :class="borderClass" class="w-4 h-4 flex-shrink-0 rounded-full border-4 mr-1"></span>
    <span>{{ style.title }}</span>
  </div>
</template>

<script>
import { ORDER_STATUS } from '@/utils/order-status'

export default {
  props   : {
    order   : Object,
    attendee: Object,
    title   : String,
    color   : String
  },
  computed: {
    borderClass () {
      switch (this.style.color) {
        case 'gray':
          return 'border-gray-500'
        case 'yellow':
          return 'border-yellow-500'
        case 'green':
          return 'border-green-500'
        case 'red':
          return 'border-red-500'
        default:
          return 'border-gray-500'
      }
    },
    style () {
      if (this.order) {
        if (this.attendee) {
          return this.attendeeStyle
        } else {
          return this.orderStyle
        }
      } else {
        return {
          title: this.title,
          color: this.color
        }
      }
    },
    orderStyle () {
      if (this.order.is_ongoing) {
        switch (this.order.status) {
          case ORDER_STATUS.ORDER_CREATED:
            return {
              title: 'Order Created',
              color: 'green'
            }
          case ORDER_STATUS.CANCELLED:
            return {
              title: 'Cancelled',
              color: 'red'
            }
          case ORDER_STATUS.SENT_TO_ATTENDEES:
            return {
              title: 'In Progress',
              color: 'yellow'
            }
          default:
            return {
              title: 'Not Determined',
              color: 'gray'
            }
        }
      } else {
        switch (this.order.status) {
          case ORDER_STATUS.CANCELLED:
            return {
              title: 'Cancelled',
              color: 'red'
            }
          case ORDER_STATUS.ORDER_CREATED:
            return {
              title: 'Order Created',
              color: 'green'
            }
          case ORDER_STATUS.SENT_TO_ATTENDEES: {

            const total = this.order.attendees_count
            const subOrders = this.order.sub_orders_total
            const completed = this.order.sub_orders_finished
            const cancelled = this.order.sub_orders_cancelled
            const inProgress = subOrders - completed - cancelled

            if (total !== 0 && total === completed) {
              return {
                title: 'Ordering in Progress',
                color: 'green'
              }
            } else if (inProgress > 0) {
              return {
                title: 'Ordering in Progress',
                color: 'yellow'
              }
            } else {
              return {
                title: 'Sent to Attendees',
                color: 'green'
              }
            }
          }
          case ORDER_STATUS.ORDERS_PLACED:
            return {
              title: 'Orders Placed',
              color: 'green'
            }
          case ORDER_STATUS.BUILDING_BOXES:
            return {
              title: 'Building Boxes',
              color: 'yellow'
            }
          case ORDER_STATUS.BOXES_BUILT:
            return {
              title: 'Boxes Built',
              color: 'green'
            }
          case ORDER_STATUS.OUT_FOR_DELIVERY:
            return {
              title: 'Out For Delivery',
              color: 'green'
            }
          case ORDER_STATUS.FULL_FILLED:
            return {
              title: 'Order Fulfilled',
              color: 'green'
            }
          default:
            return {
              title: 'Not Determined',
              color: 'gray'
            }
        }
      }
    },
    attendeeStyle () {
      if (this.attendee.invitation) {
        if (this.attendee.sub_order) {
          if (this.order.is_ongoing) {
            switch (this.attendee.sub_order.status) {
              case ORDER_STATUS.CANCELLED:
                return {
                  title: 'Cancelled',
                  color: 'red'
                }
              case ORDER_STATUS.FINISHED:
                return {
                  title: 'Orders Placed',
                  color: 'green'
                }
              case ORDER_STATUS.ORDERS_PLACED:
                return {
                  title: 'Orders Placed',
                  color: 'green'
                }
              case ORDER_STATUS.BUILDING_BOXES:
                return {
                  title: 'Building Boxes',
                  color: 'yellow'
                }
              case ORDER_STATUS.BOXES_BUILT:
                return {
                  title: 'Boxes Built',
                  color: 'green'
                }
              case ORDER_STATUS.OUT_FOR_DELIVERY:
                return {
                  title: 'Out For Delivery',
                  color: 'green'
                }
              case ORDER_STATUS.FULL_FILLED:
                return {
                  title: 'Order Fulfilled',
                  color: 'green'
                }
              default:
                return {
                  title: 'In Progress',
                  color: 'yellow'
                }
            }
          } else {
            switch (this.attendee.sub_order.status) {
              case ORDER_STATUS.CANCELLED:
                return {
                  title: 'Cancelled',
                  color: 'red'
                }
              case ORDER_STATUS.FINISHED:
                return {
                  title: 'Order Submitted',
                  color: 'green'
                }
              default:
                return {
                  title: 'In Progress',
                  color: 'yellow'
                }
            }
          }
        } else {
          return {
            title: 'Sent to Attendee',
            color: 'green'
          }
        }
      } else {
        return {
          title: 'Invite Not Sent',
          color: 'gray'
        }
      }
    }
  }
}
</script>